// ═══════════════════════════════════════════════════════════════════════════════
// Consent / PICS static chrome — English fallback for id & fil UI languages
// ═══════════════════════════════════════════════════════════════════════════════

import { LANGUAGE, type Language } from '@fdh/shared';
import { consentContent, type ConsentContent } from '../pages/consent/consentContent';

export const getConsentChromeContent = (language: Language): ConsentContent =>
  consentContent[language] ?? consentContent[LANGUAGE.EN]!;
